import FormCreateOrganization from 'Components/FormCreateOrganization';
import Modal from 'Components/Shared/Modal';

type BaseProps = {
  isOpen: boolean;
  onClose(): void;
  accountCode: string;
  accountLabel: string;
  requesterEmail?: string;
  onCompleted?(): void;
};

type CreateModeProps = BaseProps & {
  mode: 'Create';
};

type SelectModeProps = BaseProps & {
  mode: 'Select';
  organizationId: string;
  organizationName: string;
  initialDescription?: string;
};

type Props = CreateModeProps | SelectModeProps;

const ModalCreateOrganization = (props: Props) => {
  const { onClose, accountCode, accountLabel, requesterEmail, onCompleted, mode } = props;

  const title =
    mode === 'Select'
      ? 'component.modals.updateOrganization.heading'
      : 'component.modals.createOrganization.heading';

  const formProps =
    mode === 'Select'
      ? {
          mode: 'Select' as const,
          organizationId: props.organizationId,
          organizationName: props.organizationName,
          initialDescription: props.initialDescription
        }
      : { mode: 'Create' as const };

  return (
    <Modal
      {...props}
      title={title}
      maxWidth="md"
    >
      <FormCreateOrganization
        {...formProps}
        accountCode={accountCode}
        accountLabel={accountLabel}
        requesterEmail={requesterEmail}
        onCancel={onClose}
        onCompleted={onCompleted}
      />
    </Modal>
  );
};

export default ModalCreateOrganization;
